import { render } from "./DeleteEmployeeModalComponent.vue?vue&type=template&id=60d8262c&scoped=true"
import script from "./DeleteEmployeeModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteEmployeeModalComponent.vue?vue&type=script&lang=js"

import "./DeleteEmployeeModalComponent.vue?vue&type=style&index=0&id=60d8262c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d8262c"]])

export default __exports__